"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styles_1 = require("./styles");

var ReactSimpleImageViewer = /*#__PURE__*/function (_react_1$default$Comp) {
  _inherits(ReactSimpleImageViewer, _react_1$default$Comp);

  var _super = _createSuper(ReactSimpleImageViewer);

  function ReactSimpleImageViewer(props) {
    var _this;

    _classCallCheck(this, ReactSimpleImageViewer);

    _this = _super.call(this, props);
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleWheel = _this.handleWheel.bind(_assertThisInitialized(_this));
    _this.callOnClose = _this.callOnClose.bind(_assertThisInitialized(_this));
    document.addEventListener('keydown', _this.handleKeyDown);
    document.addEventListener('wheel', _this.handleWheel);
    _this.state = {
      currentIndex: _this.props.currentIndex === undefined ? 0 : _this.props.currentIndex
    };
    return _this;
  }

  _createClass(ReactSimpleImageViewer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
      document.removeEventListener('wheel', this.handleWheel);
    }
  }, {
    key: "changeImage",
    value: function changeImage(direction) {
      var nextIndex = this.state.currentIndex + direction;

      if (nextIndex > this.props.src.length - 1) {
        nextIndex = 0;
      } else if (nextIndex < 0) {
        nextIndex = this.props.src.length - 1;
      }

      this.setState({
        currentIndex: nextIndex
      });
    }
  }, {
    key: "callOnClose",
    value: function callOnClose() {
      if (this.props.onClose !== undefined) {
        this.props.onClose();
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.callOnClose();
      }

      if (['ArrowLeft', 'h'].includes(event.key)) {
        this.changeImage(-1);
      }

      if (['ArrowRight', 'l'].includes(event.key)) {
        this.changeImage(1);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      if (event.target && event.target.id === 'ReactSimpleImageViewer') {
        this.callOnClose();
      }
    }
  }, {
    key: "handleWheel",
    value: function handleWheel(event) {
      if (event.wheelDeltaY > 0) {
        this.changeImage(-1);
      } else {
        this.changeImage(1);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var src = this.props.src;
      var currentIndex = this.state.currentIndex;
      return react_1.default.createElement(styles_1.Wrapper, {
        id: "ReactSimpleImageViewer",
        onKeyDown: this.handleKeyDown,
        onClick: this.handleClick,
        className: "react-simple-image-viewer__modal",
        style: this.props.backgroundStyle
      }, react_1.default.createElement(styles_1.Close, {
        className: "react-simple-image-viewer__close",
        onClick: this.callOnClose
      }, "\xD7"), src.length > 1 && react_1.default.createElement(styles_1.Prev, {
        className: "react-simple-image-viewer__previous",
        onClick: function onClick() {
          return _this2.changeImage(-1);
        }
      }, "\u276E"), src.length > 1 && react_1.default.createElement(styles_1.Next, {
        className: "react-simple-image-viewer__next",
        onClick: function onClick() {
          return _this2.changeImage(1);
        }
      }, "\u276F"), react_1.default.createElement(styles_1.Content, {
        className: "react-simple-image-viewer__modal-content"
      }, react_1.default.createElement(styles_1.Slide, {
        className: "react-simple-image-viewer__slide"
      }, react_1.default.createElement(styles_1.Image, {
        src: src[currentIndex],
        alt: ""
      }))));
    }
  }]);

  return ReactSimpleImageViewer;
}(react_1.default.Component);

exports.default = ReactSimpleImageViewer;